module.exports = __webpack_public_path__ + "static/img/Home30@2x.2fe3cca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home30@2x.png
// module id = bani
// module chunks = 1